// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetAllSocietyDataResponse, ProxySentryResponse, GetAllData, GetAllResponse, UploadFileData, UploadFileResponse, GetAllMenuForCongressIdData, GetAllMenuForCongressIdResponse, CreateMenuData, CreateMenuResponse, UpdateMenuItemsOrderData, UpdateMenuItemsOrderResponse, UpdateData, UpdateResponse, DeleteMenuData, DeleteMenuResponse, CreateMenuItemData, CreateMenuItemResponse, UpdateMenuItemData, UpdateMenuItemResponse, DeleteMenuItemData, DeleteMenuItemResponse, GetCongressesResponse, CreateCongressData, CreateCongressResponse, GetCongressByIdData, GetCongressByIdResponse, UpdateCongressMetadataData, UpdateCongressMetadataResponse, DeleteCongressData, DeleteCongressResponse, GetCongressMetadataData, GetCongressMetadataResponse, DuplicateCongressData, DuplicateCongressResponse, MigrationCongressData, MigrationCongressResponse, GetMigrationLogsData, GetMigrationLogsResponse, GetAbstractsData, GetAbstractsResponse, GetAbstractByIdData, GetAbstractByIdResponse, GetSectionsData, GetSectionsResponse, GetSectionByIdData, GetSectionByIdResponse, GetBreaksData, GetBreaksResponse, CreateAdvertisementData, CreateAdvertisementResponse, GetAdvertisementByIdData, GetAdvertisementByIdResponse, UpdateAdvertisementData, UpdateAdvertisementResponse, DeleteAdvertisementData, DeleteAdvertisementResponse, GetAdvertisementsByCongressIdData, GetAdvertisementsByCongressIdResponse, GetAllNewsData, GetAllNewsResponse, CreateNewsData, CreateNewsResponse, GetNewsMenuItemData, GetNewsMenuItemResponse, DeleteNewsData, DeleteNewsResponse, UpsertDeviceData, UpsertDeviceResponse, GetDeviceData, GetDeviceResponse, GetAvailableDevicesData, GetAvailableDevicesResponse, CreateQuestionData, CreateQuestionResponse, FetchQuestionsData, FetchQuestionsResponse, UpdateQuestionData, UpdateQuestionResponse, CreateRatingData, CreateRatingResponse, FetchUserData, FetchUserResponse } from './types.gen';

export class SocietyService {
    /**
     * @returns SocietyData
     * @throws ApiError
     */
    public static getAllSocietyData(): CancelablePromise<GetAllSocietyDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/society'
        });
    }
    
}

export class DefaultService {
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static proxySentry(): CancelablePromise<ProxySentryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/monitoring'
        });
    }
    
}

export class FileUploadService {
    /**
     * @param data The data for the request.
     * @param data.type
     * @returns File
     * @throws ApiError
     */
    public static getAll(data: GetAllData = {}): CancelablePromise<GetAllResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/file-upload/files',
            query: {
                type: data.type
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.formData
     * @returns File The image has been successfully uploaded.
     * @throws ApiError
     */
    public static uploadFile(data: UploadFileData): CancelablePromise<UploadFileResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/file-upload/upload',
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
}

export class MenuService {
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @returns Menu
     * @throws ApiError
     */
    public static getAllMenuForCongressId(data: GetAllMenuForCongressIdData = {}): CancelablePromise<GetAllMenuForCongressIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/menu',
            query: {
                congressId: data.congressId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Menu
     * @throws ApiError
     */
    public static createMenu(data: CreateMenuData): CancelablePromise<CreateMenuResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/menu',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.menuId
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static updateMenuItemsOrder(data: UpdateMenuItemsOrderData): CancelablePromise<UpdateMenuItemsOrderResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/menu/{menuId}/order',
            path: {
                menuId: data.menuId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.menuId
     * @param data.requestBody
     * @returns Menu
     * @throws ApiError
     */
    public static update(data: UpdateData): CancelablePromise<UpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/menu/{menuId}',
            path: {
                menuId: data.menuId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.menuId
     * @returns void
     * @throws ApiError
     */
    public static deleteMenu(data: DeleteMenuData): CancelablePromise<DeleteMenuResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/menu/{menuId}',
            path: {
                menuId: data.menuId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.menuId
     * @param data.requestBody
     * @returns MenuItem
     * @throws ApiError
     */
    public static createMenuItem(data: CreateMenuItemData): CancelablePromise<CreateMenuItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/menu/{menuId}/menu-item',
            path: {
                menuId: data.menuId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.menuItemId
     * @param data.requestBody
     * @returns MenuItem
     * @throws ApiError
     */
    public static updateMenuItem(data: UpdateMenuItemData): CancelablePromise<UpdateMenuItemResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/menu/menu-item/{menuItemId}',
            path: {
                menuItemId: data.menuItemId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.menuItemId
     * @returns void
     * @throws ApiError
     */
    public static deleteMenuItem(data: DeleteMenuItemData): CancelablePromise<DeleteMenuItemResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/menu/menu-item/{menuItemId}',
            path: {
                menuItemId: data.menuItemId
            }
        });
    }
    
}

export class CongressesService {
    /**
     * @returns Congress
     * @throws ApiError
     */
    public static getCongresses(): CancelablePromise<GetCongressesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/congresses'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Congress
     * @throws ApiError
     */
    public static createCongress(data: CreateCongressData): CancelablePromise<CreateCongressResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/congresses',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @returns CongressData
     * @throws ApiError
     */
    public static getCongressById(data: GetCongressByIdData): CancelablePromise<GetCongressByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/congresses/{congressId}',
            path: {
                congressId: data.congressId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @param data.requestBody
     * @returns Congress
     * @throws ApiError
     */
    public static updateCongressMetadata(data: UpdateCongressMetadataData): CancelablePromise<UpdateCongressMetadataResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/congresses/{congressId}',
            path: {
                congressId: data.congressId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @param data.requestBody
     * @returns void
     * @throws ApiError
     */
    public static deleteCongress(data: DeleteCongressData): CancelablePromise<DeleteCongressResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/congresses/{congressId}',
            path: {
                congressId: data.congressId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @returns Congress
     * @throws ApiError
     */
    public static getCongressMetadata(data: GetCongressMetadataData): CancelablePromise<GetCongressMetadataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/congresses/{congressId}/metadata',
            path: {
                congressId: data.congressId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @returns Congress
     * @throws ApiError
     */
    public static duplicateCongress(data: DuplicateCongressData): CancelablePromise<DuplicateCongressResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/congresses/{congressId}/duplicate',
            path: {
                congressId: data.congressId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @returns MigrationResult
     * @throws ApiError
     */
    public static migrationCongress(data: MigrationCongressData): CancelablePromise<MigrationCongressResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/congresses/{congressId}/migration',
            path: {
                congressId: data.congressId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @returns MigrationLog
     * @throws ApiError
     */
    public static getMigrationLogs(data: GetMigrationLogsData): CancelablePromise<GetMigrationLogsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/congresses/{congressId}/migration-logs',
            path: {
                congressId: data.congressId
            }
        });
    }
    
}

export class AbstractsService {
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @param data.search
     * @param data.limit
     * @param data.offset
     * @param data.sortBy
     * @param data.sortOrder
     * @returns AbstractListPagination
     * @throws ApiError
     */
    public static getAbstracts(data: GetAbstractsData): CancelablePromise<GetAbstractsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/abstracts/{congressId}/all',
            path: {
                congressId: data.congressId
            },
            query: {
                search: data.search,
                limit: data.limit,
                offset: data.offset,
                sortBy: data.sortBy,
                sortOrder: data.sortOrder
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns Abstract
     * @throws ApiError
     */
    public static getAbstractById(data: GetAbstractByIdData): CancelablePromise<GetAbstractByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/abstracts/{id}',
            path: {
                id: data.id
            }
        });
    }
    
}

export class SectionsService {
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @param data.search
     * @param data.limit
     * @param data.offset
     * @param data.sortBy
     * @param data.sortOrder
     * @returns SectionListPagination
     * @throws ApiError
     */
    public static getSections(data: GetSectionsData): CancelablePromise<GetSectionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sections/{congressId}/all',
            path: {
                congressId: data.congressId
            },
            query: {
                search: data.search,
                limit: data.limit,
                offset: data.offset,
                sortBy: data.sortBy,
                sortOrder: data.sortOrder
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns Section
     * @throws ApiError
     */
    public static getSectionById(data: GetSectionByIdData): CancelablePromise<GetSectionByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sections/{id}',
            path: {
                id: data.id
            }
        });
    }
    
}

export class BreaksService {
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @param data.search
     * @param data.limit
     * @param data.offset
     * @returns BreakPagination
     * @throws ApiError
     */
    public static getBreaks(data: GetBreaksData): CancelablePromise<GetBreaksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/breaks/{congressId}',
            path: {
                congressId: data.congressId
            },
            query: {
                search: data.search,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
}

export class AdvertisementsService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Advertisement
     * @throws ApiError
     */
    public static createAdvertisement(data: CreateAdvertisementData): CancelablePromise<CreateAdvertisementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/advertisements',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Get advertisement by id
     * @param data The data for the request.
     * @param data.id
     * @returns Advertisement Advertisement found
     * @throws ApiError
     */
    public static getAdvertisementById(data: GetAdvertisementByIdData): CancelablePromise<GetAdvertisementByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/advertisements/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Update advertisement
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns Advertisement Advertisement updated successfully
     * @throws ApiError
     */
    public static updateAdvertisement(data: UpdateAdvertisementData): CancelablePromise<UpdateAdvertisementResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/advertisements/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Delete advertisement
     * @param data The data for the request.
     * @param data.id
     * @returns unknown Advertisement deleted successfully
     * @throws ApiError
     */
    public static deleteAdvertisement(data: DeleteAdvertisementData): CancelablePromise<DeleteAdvertisementResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/advertisements/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Get advertisements by congress id
     * @param data The data for the request.
     * @param data.congressId
     * @returns Advertisement List of advertisements for congress
     * @throws ApiError
     */
    public static getAdvertisementsByCongressId(data: GetAdvertisementsByCongressIdData): CancelablePromise<GetAdvertisementsByCongressIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/advertisements/congress/{congressId}',
            path: {
                congressId: data.congressId
            }
        });
    }
    
}

export class NewsService {
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @param data.includeFuture
     * @returns News
     * @throws ApiError
     */
    public static getAllNews(data: GetAllNewsData = {}): CancelablePromise<GetAllNewsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/news',
            query: {
                congressId: data.congressId,
                includeFuture: data.includeFuture
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.congressId
     * @param data.includeFuture
     * @returns News
     * @throws ApiError
     */
    public static createNews(data: CreateNewsData): CancelablePromise<CreateNewsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/news',
            query: {
                congressId: data.congressId,
                includeFuture: data.includeFuture
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @returns unknown
     * @throws ApiError
     */
    public static getNewsMenuItem(data: GetNewsMenuItemData = {}): CancelablePromise<GetNewsMenuItemResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/news/menu-item',
            query: {
                congressId: data.congressId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns void
     * @throws ApiError
     */
    public static deleteNews(data: DeleteNewsData): CancelablePromise<DeleteNewsResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/news/{id}',
            path: {
                id: data.id
            }
        });
    }
    
}

export class NotificationsService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Device
     * @throws ApiError
     */
    public static upsertDevice(data: UpsertDeviceData): CancelablePromise<UpsertDeviceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notifications',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.deviceId
     * @param data.congressId
     * @returns NotificationStatusResponse
     * @throws ApiError
     */
    public static getDevice(data: GetDeviceData): CancelablePromise<GetDeviceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications/{deviceId}',
            path: {
                deviceId: data.deviceId
            },
            query: {
                congressId: data.congressId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @returns NotificationAnalytics
     * @throws ApiError
     */
    public static getAvailableDevices(data: GetAvailableDevicesData): CancelablePromise<GetAvailableDevicesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications/analytics/{congressId}',
            path: {
                congressId: data.congressId
            }
        });
    }
    
}

export class QaService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns QA
     * @throws ApiError
     */
    public static createQuestion(data: CreateQuestionData): CancelablePromise<CreateQuestionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/qa',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.congressId
     * @param data.eventType
     * @param data.contentId
     * @returns QA
     * @throws ApiError
     */
    public static fetchQuestions(data: FetchQuestionsData): CancelablePromise<FetchQuestionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/qa',
            query: {
                congressId: data.congressId,
                eventType: data.eventType,
                contentId: data.contentId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static updateQuestion(data: UpdateQuestionData): CancelablePromise<UpdateQuestionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/qa/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class RatingService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Rating
     * @throws ApiError
     */
    public static createRating(data: CreateRatingData): CancelablePromise<CreateRatingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/rating',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class UserService {
    /**
     * @param data The data for the request.
     * @param data.userId
     * @returns UserWithCongress
     * @throws ApiError
     */
    public static fetchUser(data: FetchUserData): CancelablePromise<FetchUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/{userId}',
            path: {
                userId: data.userId
            }
        });
    }
    
}